module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f07503_banner_800x600.a251aaa9.png";